import { api } from "./api";

export type NotificationItem = {
  id: string;
  kind: string;
  title: string;
  body: string | null;
  url: string | null;
  icon: string | null;
  read_at: string | null;
  created_at: string;
};

export type NotificationList = {
  items: NotificationItem[];
  unread_count: number;
  total: number;
};

export const listNotifications = (unreadOnly = false) => {
  const q = unreadOnly ? "?unread_only=true" : "";
  return api.get<NotificationList>(`/agent/notifications${q}`);
};

export const getUnreadCount = () =>
  api.get<{ unread_count: number }>("/agent/notifications/unread-count");

export const markRead = (id: string) =>
  api.post<NotificationItem>(`/agent/notifications/${id}/read`);

export const markAllRead = () =>
  api.post<{ marked: number }>("/agent/notifications/read-all");
